var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-row",
        [
          _c(
            "el-col",
            { attrs: { lg: 7, md: 9, sm: 12, span: 6, xl: 6, xs: 24 } },
            [
              _c("img", {
                staticStyle: { width: "100%" },
                attrs: { alt: "", src: "images/height-gsc.png" },
              }),
            ]
          ),
          _c(
            "el-col",
            { attrs: { lg: 16, md: 14, sm: 12, span: 18, xl: 18, xs: 24 } },
            [
              _c(
                "div",
                { staticStyle: { "margin-left": "16px" } },
                [
                  _c("h2", [_vm._v("国寿财高危行业4-6类团意险")]),
                  _c("div", [_vm._v("行业超低价 | 国寿财险 | 全线上操作")]),
                  _c("p", [
                    _vm._v(
                      "\n\t\t\t\t\t\t① 多档调节，随心选择；\n\t\t\t\t\t\t"
                    ),
                    _c("br"),
                    _vm._v("\n\t\t\t\t\t\t② 投保简便支持月单；\n\t\t\t\t\t\t"),
                    _c("br"),
                    _vm._v("\n\t\t\t\t\t\t③ 社保用药100%赔付；\n\t\t\t\t\t\t"),
                    _c("br"),
                    _vm._v(
                      "\n\t\t\t\t\t\t④ 5人起保，保额高达100万；\n\t\t\t\t\t"
                    ),
                  ]),
                  _c(
                    "div",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { size: "medium", type: "warning" },
                          nativeOn: {
                            click: function ($event) {
                              return _vm.handleInsure(0)
                            },
                          },
                        },
                        [_vm._v("立即投保")]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { size: "medium", type: "primary" },
                          nativeOn: {
                            click: function ($event) {
                              return _vm.handleInsure(1)
                            },
                          },
                        },
                        [_vm._v("投保计划书")]
                      ),
                    ],
                    1
                  ),
                  _c("br"),
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-top": "5px" },
                      attrs: {
                        loading: _vm.isDownLoading,
                        icon: "el-icon-download",
                        size: "medium",
                        type: "text",
                      },
                      nativeOn: {
                        click: function ($event) {
                          return _vm.handleDownLoad.apply(null, arguments)
                        },
                      },
                    },
                    [_vm._v("\n\t\t\t\t\t\t下载国寿财职业类别表\n\t\t\t\t\t")]
                  ),
                ],
                1
              ),
            ]
          ),
        ],
        1
      ),
      _c(
        "el-tabs",
        {
          model: {
            value: _vm.currentStep,
            callback: function ($$v) {
              _vm.currentStep = $$v
            },
            expression: "currentStep",
          },
        },
        [
          _c(
            "el-tab-pane",
            { attrs: { label: "保险详情", name: "0" } },
            [
              _c(
                "el-card",
                [
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _vm._v("\n\t\t\t\t\t\t\t价格方案：\n\t\t\t\t\t\t\t"),
                          _c(
                            "el-radio-group",
                            {
                              on: { change: _vm.computePrice },
                              model: {
                                value: _vm.dangci,
                                callback: function ($$v) {
                                  _vm.dangci = $$v
                                },
                                expression: "dangci",
                              },
                            },
                            [
                              _c(
                                "el-radio",
                                { attrs: { label: 0, border: "" } },
                                [_vm._v("1档")]
                              ),
                              _c(
                                "el-radio",
                                { attrs: { label: 2, border: "" } },
                                [_vm._v("3档")]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _vm._v("\n\t\t\t\t\t\t\t保障期限：\n\t\t\t\t\t\t\t"),
                          _c(
                            "el-select",
                            {
                              attrs: { placeholder: "请选择保障期限" },
                              on: { change: _vm.computePrice },
                              model: {
                                value: _vm.qixian,
                                callback: function ($$v) {
                                  _vm.qixian = $$v
                                },
                                expression: "qixian",
                              },
                            },
                            _vm._l(_vm.qixians, function (item) {
                              return _c("el-option", {
                                key: item.value,
                                attrs: { label: item.label, value: item.value },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c("avue-crud", {
                    ref: "crud",
                    attrs: {
                      data: _vm.dataPlan,
                      option: _vm.optionPlan,
                      "span-method": _vm.spanMethodPlan,
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-tab-pane",
            { attrs: { label: "常见问题", name: "1" } },
            [
              _c(
                "el-row",
                [
                  _c("el-col", { attrs: { span: 24 } }, [
                    _c(
                      "ul",
                      _vm._l(_vm.dataQA, function (qa) {
                        return _c(
                          "li",
                          { key: qa.question },
                          [
                            _c("div", [
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    display: "inline-block",
                                    width: "20px",
                                    "text-align": "center",
                                    "background-color": "MediumPurple",
                                    color: "white",
                                    padding: "4px",
                                    "border-radius": "4px",
                                    "margin-right": "8px",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t\t\t\tQ\n\t\t\t\t\t\t\t\t\t"
                                  ),
                                ]
                              ),
                              _c(
                                "span",
                                { staticStyle: { "font-weight": "bold" } },
                                [_vm._v(_vm._s(qa.question))]
                              ),
                            ]),
                            _c("p"),
                            _c("div", [
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    display: "inline-block",
                                    width: "20px",
                                    "background-color": "MediumSeaGreen",
                                    color: "white",
                                    padding: "4px",
                                    "border-radius": "4px",
                                    "margin-right": "8px",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t\t\t\tA\n\t\t\t\t\t\t\t\t\t"
                                  ),
                                ]
                              ),
                              _c("span", {
                                domProps: { innerHTML: _vm._s(qa.answer) },
                              }),
                            ]),
                            _c("el-divider"),
                          ],
                          1
                        )
                      }),
                      0
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-tab-pane",
            { attrs: { label: "投保须知", name: "2" } },
            [
              _c(
                "el-row",
                [
                  _c("el-col", { attrs: { span: 24 } }, [
                    _c("h2", { staticStyle: { color: "red" } }, [
                      _vm._v("【一、产品责任/保障方案介绍】"),
                    ]),
                    _c(
                      "div",
                      {
                        staticStyle: {
                          "line-height": "28px",
                          "margin-left": "20px",
                        },
                      },
                      [
                        _c("span", { staticClass: "font_title" }, [
                          _vm._v("本产品相关保险条件："),
                        ]),
                        _c("br"),
                        _c("span", { staticClass: "font_title" }, [
                          _vm._v(
                            "1、每一被保险人在同一保险期间内限投保壹份，多投保无效。"
                          ),
                        ]),
                        _c("br"),
                        _c("span", { staticClass: "font_title" }, [
                          _vm._v("2、保险期间"),
                        ]),
                        _c("br"),
                        _c("div", { staticStyle: { "margin-left": "20px" } }, [
                          _vm._v(
                            "\n\t\t\t\t\t\t\t\t本产品保险期间为1年（含短期单：6个月、3个月、1个月，费率以条款短期费率为准），以保险合同载明的起讫时间为准。\n\t\t\t\t\t\t\t\t"
                          ),
                          _c("br"),
                          _c(
                            "span",
                            { staticStyle: { "font-weight": "bold" } },
                            [
                              _vm._v(
                                "\n\t\t\t\t\t\t\t\t\t本产品保单自您完成投保操作并成功支付保险费之日T+2日零时生效。保单生效后，保险人开始承担保险责任，保单生效前发生的保险事故，保险人不承担保险责任。\n\t\t\t\t\t\t\t\t"
                              ),
                            ]
                          ),
                        ]),
                        _c("span", { staticClass: "font_title" }, [
                          _vm._v("3、医院机构就诊范围"),
                        ]),
                        _c("br"),
                        _c("span", { staticStyle: { "margin-left": "20px" } }, [
                          _vm._v(
                            "\n\t\t\t\t\t\t\t\t本产品适用的就诊医疗机构范围为：中华人民共和国境内（不含港、澳、台地区）二级及以上医院或者保险人指定或认可的医疗机构。但不包括以下地区的医疗机构：天津静海区、滨海新区；河北省沧州市、廊坊市、三河市、秦皇岛青龙县；湖北黄冈市、麻城市、荆州市。对于前往非本保单指定就诊医院所产生的医疗费用，保险人有权拒绝赔偿。\n\t\t\t\t\t\t\t"
                          ),
                        ]),
                        _c("br"),
                        _c("span", { staticClass: "font_title" }, [
                          _vm._v("4、医疗费用免赔额及给付比例"),
                        ]),
                        _c("br"),
                        _c("span", { staticStyle: { "margin-left": "20px" } }, [
                          _vm._v(
                            "\n\t\t\t\t\t\t\t\t对被保险人所支出的必要、合理的且属于当地社会医疗保险报销范围的意外伤害医疗费用，保险人每次扣除绝对免赔额RMB0元后，在意外伤害医疗费用保险金额范围内按照100%比例给付。\n\t\t\t\t\t\t\t"
                          ),
                        ]),
                        _c("br"),
                        _c("span", { staticStyle: { "margin-left": "20px" } }, [
                          _vm._v(
                            "\n\t\t\t\t\t\t\t\t保险期间届满被保险人治疗仍未结束的，保险人继续承担给付保险金责任的期限，门诊治疗者，自保险期间届满次日起计算，以15日为限；住院治疗者至出院之日止，自保险期间届满次日起计算，最长以90日为限。\n\t\t\t\t\t\t\t"
                          ),
                        ]),
                        _c("br"),
                        _c("span", { staticClass: "font_title" }, [
                          _vm._v("5、等待期"),
                        ]),
                        _c("br"),
                        _c("span", { staticStyle: { "margin-left": "20px" } }, [
                          _vm._v(
                            "\n\t\t\t\t\t\t\t\t本产品无等待期（指自保险期间开始之日起至保险责任开始之日止的时段）。\n\t\t\t\t\t\t\t"
                          ),
                        ]),
                        _c("br"),
                        _c("span", { staticClass: "font_title" }, [
                          _vm._v("6、特别约定"),
                        ]),
                        _c("br"),
                        _c(
                          "div",
                          {
                            staticStyle: {
                              "margin-left": "20px",
                              "font-weight": "bold",
                            },
                          },
                          [
                            _vm._v("\n\t\t\t\t\t\t\t\t(1)、\n\t\t\t\t\t\t\t\t"),
                            _c("span", { staticClass: "red-bold" }, [
                              _vm._v(
                                "\n\t\t\t\t\t\t\t\t\t出险后，被保险人必须在72小时内通过微信小程序“线上快赔”上传出险照片报案，报案服务咨询可拨打本保单第11条特别约定中的电话号码，取得报案号后才是报案成功(否则报案失败)。\n\t\t\t\t\t\t\t\t"
                              ),
                            ]),
                            _vm._v(
                              "\n\t\t\t\t\t\t\t\t如果被保险人委托第三人/第三方报案，后被保险人必须及时联系第三人/第三方，获取报案号。否则因第三人/第三方延迟报案，导致保险人按本保单第11条特别约定扣除免赔，那么被保险人须自行承担相关损失。\n\t\t\t\t\t\t\t\t"
                            ),
                            _c("br"),
                            _vm._v(
                              "\n\t\t\t\t\t\t\t\t(2)、本保单承保的职业类别按风险从低到高，可分为4-6类，6类风险最高。\n\t\t\t\t\t\t\t\t"
                            ),
                            _c("br"),
                            _vm._v("\n\t\t\t\t\t\t\t\t(3)、\n\t\t\t\t\t\t\t\t"),
                            _c("span", { staticClass: "red-bold" }, [
                              _vm._v(
                                "\n\t\t\t\t\t\t\t\t\t本保单拒绝承保职业（即保险人不承担任何赔偿责任）：农牧渔业、海上作业、地质矿产业、化工/军工制造业、影视及演艺业、建筑物外墙维护及玻璃幕墙安装维护人员、特别约定桥梁/隧道工程人员、凿岩工、防水工、水运工程施工、水坝工程人员、潜水工作人员、体育运动、各种杂技人员、驯兽师、涉及火药/炸药/爆破的相关工作、易燃易爆/危险化学品运输司机及随车工、特种兵/军人/武警/公安/警察/消防等治安人员、高压电工作人员、快递/外卖配送等。\n\t\t\t\t\t\t\t\t"
                              ),
                            ]),
                            _c("br"),
                            _vm._v("\n\t\t\t\t\t\t\t\t(4)、\n\t\t\t\t\t\t\t\t"),
                            _c("span", { staticClass: "red-bold" }, [
                              _vm._v(
                                "\n\t\t\t\t\t\t\t\t\t兹保险双方协商并同意，若从事高处作业，必须投保5-6类职业，否则发生保险事故，保险人不承担赔偿责任。\n\t\t\t\t\t\t\t\t"
                              ),
                            ]),
                            _vm._v(
                              "\n\t\t\t\t\t\t\t\t高处作业以《高处作业分级标准》（中华人民共和国国家标准GB3608-2008）中的定义为准。\n\t\t\t\t\t\t\t\t"
                            ),
                            _c("span", { staticClass: "red-bold" }, [
                              _vm._v(
                                "\n\t\t\t\t\t\t\t\t\t从事高处作业须系安全带，且须持有有效的特种作业操作证（高处作业），否则保险人对按保单规定的应承担的保险责任，免赔50%。\n\t\t\t\t\t\t\t\t"
                              ),
                            ]),
                            _c("br"),
                            _vm._v("\n\t\t\t\t\t\t\t\t(5)、\n\t\t\t\t\t\t\t\t"),
                            _c("span", { staticClass: "red-bold" }, [
                              _vm._v(
                                "\n\t\t\t\t\t\t\t\t\t兹保险双方协商并同意，投保4类职业的人员，若从事高处作业发生保险事故，则保险人不承担赔偿责任；若从事其他5-6类职业工作（不涉及高处作业）发生保险事故，则保险人对按保单约定的应承担的保险责任，免赔50%。\n\t\t\t\t\t\t\t\t"
                              ),
                            ]),
                            _c("br"),
                            _vm._v(
                              "\n\t\t\t\t\t\t\t\t(6)、以下情形，保险人不得以保单上列明职业有误而拒赔或者减少承担赔偿责任：保单上列明职业类别对应的保费，不低于被保险人实际职业类别对应的保费。\n\t\t\t\t\t\t\t\t"
                            ),
                            _c("br"),
                            _vm._v(
                              "\n\t\t\t\t\t\t\t\t(7)、兹保险双方协商并同意，本保单不支持批减被保险人、变更保额。保险期限为3个月以内（含）的保单不支持替换被保险人，6个月和1年的保单支持替换被保险人（已出险人员除外）。\n\t\t\t\t\t\t\t\t"
                            ),
                            _c("br"),
                            _vm._v(
                              "\n\t\t\t\t\t\t\t\t(8)、保险人赔付标准如下：\n\t\t\t\t\t\t\t\t"
                            ),
                            _c("br"),
                            _vm._v(
                              "\n\t\t\t\t\t\t\t\t① 对于身故：按限额100%赔付。\n\t\t\t\t\t\t\t\t"
                            ),
                            _c("br"),
                            _vm._v(
                              "\n\t\t\t\t\t\t\t\t②\n\t\t\t\t\t\t\t\t对于伤残：经司法鉴定后，伤残按一级100%、二级90%、三级80%、四级70%、五级60%、六级50%、七级40%、八级30%、九级20%、10级10%的比例赔付。\n\t\t\t\t\t\t\t\t"
                            ),
                            _c("br"),
                            _vm._v(
                              "\n\t\t\t\t\t\t\t\t③\n\t\t\t\t\t\t\t\t对于医疗费用：保险人按投保人营业执照注册地（地市级以上）劳动、卫生、社保行政部门公布的城镇职工医疗保险的范围及标准赔付。\n\t\t\t\t\t\t\t\t"
                            ),
                            _c("span", { staticClass: "red-bold" }, [
                              _vm._v(
                                "\n\t\t\t\t\t\t\t\t\t保险期间届满被保险人治疗仍未结束的，保险人继续承担给付保险金责任的期限，门诊治疗者，自保险期间届满次日起计算，以15日为限；住院治疗者至出院之日止，自保险期间届满次日起计算，最长以90日为限。\n\t\t\t\t\t\t\t\t"
                              ),
                            ]),
                            _c("br"),
                            _vm._v("\n\t\t\t\t\t\t\t\t④\n\t\t\t\t\t\t\t\t"),
                            _c("span", { staticClass: "red-bold" }, [
                              _vm._v(
                                "\n\t\t\t\t\t\t\t\t\t对于住院津贴：在保险期间内每次事故赔偿不超过90天，累计不超过180天，无免赔。\n\t\t\t\t\t\t\t\t"
                              ),
                            ]),
                            _vm._v(
                              "\n\t\t\t\t\t\t\t\t身故/伤残保额10-30万的方案，每人每天100元；40-70万的方案，每人每天150元；80-100万的方案，每人每天200元。\n\t\t\t\t\t\t\t\t"
                            ),
                            _c("br"),
                            _vm._v("\n\t\t\t\t\t\t\t\t(9)、\n\t\t\t\t\t\t\t\t"),
                            _c("span", { staticClass: "red-bold" }, [
                              _vm._v(
                                "\n\t\t\t\t\t\t\t\t\t本保单指定就诊医院为大陆境内二级及以上公立医院，或保险人认可的其他医疗机构（如被保险人所在乡镇的公立医疗机构），但不包括以下地区的医疗机构：天津静海区、滨海新区；河北省沧州市、廊坊市、三河市、秦皇岛青龙县；湖北黄冈市、麻城市、荆州市。\n\t\t\t\t\t\t\t\t"
                              ),
                            ]),
                            _vm._v(
                              "\n\t\t\t\t\t\t\t\t对于前往非本保单指定就诊医院所产生的医疗费用，保险人有权拒绝赔偿。\n\t\t\t\t\t\t\t\t"
                            ),
                            _c("br"),
                            _vm._v(
                              "\n\t\t\t\t\t\t\t\t(10)、\n\t\t\t\t\t\t\t\t"
                            ),
                            _c("span", { staticClass: "red-bold" }, [
                              _vm._v("保险人不赔偿如下责任："),
                            ]),
                            _c("br"),
                            _vm._v("\n\t\t\t\t\t\t\t\t①\n\t\t\t\t\t\t\t\t"),
                            _c("span", { staticClass: "red-bold" }, [
                              _vm._v("拒绝承保职业。"),
                            ]),
                            _c("br"),
                            _vm._v("\n\t\t\t\t\t\t\t\t②\n\t\t\t\t\t\t\t\t"),
                            _c("span", { staticClass: "red-bold" }, [
                              _vm._v("保险条款责任免除部分。"),
                            ]),
                            _c("br"),
                            _vm._v("\n\t\t\t\t\t\t\t\t③\n\t\t\t\t\t\t\t\t"),
                            _c("span", { staticClass: "red-bold" }, [
                              _vm._v("精神损害、猝死、疾病所致治疗和身故。"),
                            ]),
                            _c("br"),
                            _vm._v(
                              "\n\t\t\t\t\t\t\t\t(11)、\n\t\t\t\t\t\t\t\t"
                            ),
                            _c("span", { staticClass: "red-bold" }, [
                              _vm._v(
                                "\n\t\t\t\t\t\t\t\t\t兹保险双方协商并同意，被保险人必须在保险事故发生后24小时内拨打电话400-180-1616进行报案（如属于死亡或重伤事故，须在12小时内报案），因延迟报案影响保险人查勘、定损的，保险人对无法核实的部分不承担任何赔偿责任；如果被保险人超过72小时才报案，则保险人对按保单约定的应承担的保险责任，免赔50%；\n\t\t\t\t\t\t\t\t"
                              ),
                            ]),
                            _vm._v(
                              "\n\t\t\t\t\t\t\t\t如果事故发生日期早于本保单生效日期，被保险人通过对事故发生日期造假的方式，从而在本保单提出索赔的行为则属于骗保，保险人有权追究被保险人及相关人员的刑事责任。\n\t\t\t\t\t\t\t\t"
                            ),
                            _c("br"),
                            _vm._v(
                              "\n\t\t\t\t\t\t\t\t(12)、兹保险双方协商并同意，本保单累计赔偿限额为1000万。若伤亡事故造成的实际损失超1000万，对于超过部分，保险人不承担赔偿责任。\n\t\t\t\t\t\t\t\t"
                            ),
                            _c("br"),
                            _vm._v(
                              "\n\t\t\t\t\t\t\t\t(13)、本保单扩展年龄规范保险条款，本保单承保被保险人年龄区间须为十六周岁（含）至六十五周岁（含）。\n\t\t\t\t\t\t\t"
                            ),
                          ]
                        ),
                        _c("span", { staticClass: "font_title" }, [
                          _vm._v("7、责任免除"),
                        ]),
                        _c("br"),
                        _c("span", { staticClass: "font_head" }, [
                          _vm._v(
                            "\n\t\t\t\t\t\t\t\t“中国人寿财产保险股份有限公司人身意外伤害保险（2022版）（互联网专属）”责任免除详情\n\t\t\t\t\t\t\t"
                          ),
                        ]),
                        _c(
                          "span",
                          {
                            staticClass: "font_head",
                            staticStyle: { color: "red" },
                          },
                          [
                            _vm._v(
                              "\n\t\t\t\t\t\t\t\t以下内容请您务必认真阅读！以下内容涵盖了本产品保险合同约定的主要免除责任，即保险公司不承担给付保险金责任或仅赔付部分保险金的情形。详细的责任免除相关内容请见《保险条款》。\n\t\t\t\t\t\t\t"
                            ),
                          ]
                        ),
                        _c(
                          "span",
                          {
                            staticClass: "font_head font_center",
                            staticStyle: {
                              color: "red",
                              "text-align": "center",
                            },
                          },
                          [
                            _vm._v(
                              "\n\t\t\t\t\t\t\t\t★保险公司不予给付保险金的责任免除★\n\t\t\t\t\t\t\t"
                            ),
                          ]
                        ),
                        _c(
                          "span",
                          {
                            staticClass: "font_head",
                            staticStyle: { color: "red" },
                          },
                          [
                            _vm._v(
                              "\n\t\t\t\t\t\t\t\t《中国人寿财产保险股份有限公司人身意外伤害保险（2022版）（互联网专属）条款（注册编号：C00010832312022042867271）》\n\t\t\t\t\t\t\t"
                            ),
                          ]
                        ),
                        _c("span", { staticClass: "font_title" }, [
                          _vm._v(
                            "\n\t\t\t\t\t\t\t\t因下列原因造成被保险人身故、伤残、支出医疗费用、住院治疗、突发急性病身故或猝死的，保险人不承担给付保险金责任：\n\t\t\t\t\t\t\t"
                          ),
                        ]),
                        _c("br"),
                        _c("div", { staticStyle: { "margin-left": "20px" } }, [
                          _vm._v(
                            "\n\t\t\t\t\t\t\t\t（一）投保人的故意或重大过失行为；\n\t\t\t\t\t\t\t\t"
                          ),
                          _c("br"),
                          _vm._v(
                            "\n\t\t\t\t\t\t\t\t（二）被保险人自致伤害或自杀，但被保险人自致伤害或自杀时为无民事行为能力人的除外；\n\t\t\t\t\t\t\t\t"
                          ),
                          _c("br"),
                          _vm._v(
                            "\n\t\t\t\t\t\t\t\t（三）因被保险人挑衅或故意行为而导致的打斗、被袭击或被谋杀；\n\t\t\t\t\t\t\t\t"
                          ),
                          _c("br"),
                          _vm._v(
                            "\n\t\t\t\t\t\t\t\t（四）猝死或突发急性病（该被保险人已投保突发急性病身故或猝死保险责任的不在此限）、其他疾病(包括但不限于高原反应、中暑、过敏及由过敏引发的变态反应)或其他自身身体原因；\n\t\t\t\t\t\t\t\t"
                          ),
                          _c("br"),
                          _vm._v(
                            "\n\t\t\t\t\t\t\t\t（五）投保前已有的残疾及其并发症；\n\t\t\t\t\t\t\t\t"
                          ),
                          _c("br"),
                          _vm._v(
                            "\n\t\t\t\t\t\t\t\t（六）被保险人接受整容手术、其他内、外科手术或其他诊疗活动过程中发生的医疗意外和医疗损害；\n\t\t\t\t\t\t\t\t"
                          ),
                          _c("br"),
                          _vm._v(
                            "\n\t\t\t\t\t\t\t\t（七）被保险人未遵医嘱，私自服用、涂用、注射药物；\n\t\t\t\t\t\t\t\t"
                          ),
                          _c("br"),
                          _vm._v(
                            "\n\t\t\t\t\t\t\t\t（八）被保险人洗牙、洁齿、验光、装配假眼、假牙、假肢或者助听器等；\n\t\t\t\t\t\t\t\t"
                          ),
                          _c("br"),
                          _vm._v(
                            "\n\t\t\t\t\t\t\t\t（九）投保人、被保险人故意导致发病或发病后故意不及时就医的，但被保险人为无民事行为能力人的除外。\n\t\t\t\t\t\t\t\t"
                          ),
                          _c("br"),
                          _vm._v(
                            "\n\t\t\t\t\t\t\t\t发生上述情形，被保险人身故的，保险人对该被保险人的保险责任终止，向投保人退还该被保险人的未满期净保费，如投保人、被保险人故意制造保险事故的，不退还保险费。\n\t\t\t\t\t\t\t\t"
                          ),
                          _c("br"),
                          _c("span", { staticClass: "font_title" }, [
                            _vm._v(
                              "\n\t\t\t\t\t\t\t\t\t出现下列任一情形，导致被保险人身故、伤残、支出医疗费用、住院治疗、突发急性病身故或猝死的，保险人不承担给付保险金责任：\n\t\t\t\t\t\t\t\t"
                            ),
                          ]),
                          _c("br"),
                          _vm._v(
                            "\n\t\t\t\t\t\t\t\t（一）被保险人妊娠、流产、分娩、不孕症、避孕及绝育手术、先天性畸形、变形或染色体异常；\n\t\t\t\t\t\t\t\t"
                          ),
                          _c("br"),
                          _vm._v(
                            "\n\t\t\t\t\t\t\t\t（二）任何生物、化学、原子能武器，原子能或核能装置所造成的爆炸、灼伤、污染或辐射；\n\t\t\t\t\t\t\t\t"
                          ),
                          _c("br"),
                          _vm._v(
                            "\n\t\t\t\t\t\t\t\t（三）战争、军事行动、暴动或武装叛乱、恐怖袭击；\n\t\t\t\t\t\t\t\t"
                          ),
                          _c("br"),
                          _vm._v(
                            "\n\t\t\t\t\t\t\t\t（四）被保险人从事非法、犯罪活动期间或被依法拘留、服刑期间；\n\t\t\t\t\t\t\t\t"
                          ),
                          _c("br"),
                          _vm._v(
                            "\n\t\t\t\t\t\t\t\t（五）被保险人醉酒或受毒品、管制药物的影响期间；\n\t\t\t\t\t\t\t\t"
                          ),
                          _c("br"),
                          _vm._v(
                            "\n\t\t\t\t\t\t\t\t（六）被保险人酒后驾驶、无有效驾驶证驾驶或驾驶无有效行驶证的机动车期间；\n\t\t\t\t\t\t\t\t"
                          ),
                          _c("br"),
                          _vm._v(
                            "\n\t\t\t\t\t\t\t\t（七）被保险人从事潜水、跳伞、攀岩运动、探险活动、武术比赛、摔跤比赛、特技表演、赛马、赛车等高风险活动期间；\n\t\t\t\t\t\t\t\t"
                          ),
                          _c("br"),
                          _vm._v(
                            "\n\t\t\t\t\t\t\t\t（八）被保险人在家自设病床治疗、健康保健治疗、康复疗养治疗和非医疗行为的治疗等；\n\t\t\t\t\t\t\t\t"
                          ),
                          _c("br"),
                          _vm._v(
                            "\n\t\t\t\t\t\t\t\t（九）住院治疗的，无医院有效的转院证明而自行转院的；\n\t\t\t\t\t\t\t\t"
                          ),
                          _c("br"),
                          _vm._v(
                            "\n\t\t\t\t\t\t\t\t（十）本条款中载明的保险期间外发病的；\n\t\t\t\t\t\t\t\t"
                          ),
                          _c("br"),
                          _vm._v(
                            "\n\t\t\t\t\t\t\t\t（十一）突发急性病身故条款中载明的抢救期后身故的。\n\t\t\t\t\t\t\t\t"
                          ),
                          _c("br"),
                        ]),
                        _c("span", { staticClass: "font_title" }, [
                          _vm._v(
                            "\n\t\t\t\t\t\t\t\t根据本保险条款的相关约定，保险人应不承担或免除保险责任的各种情形下的损失、费用或责任，或保险人有权予以扣除、减少的部分，保险人不负责给付保险金。\n\t\t\t\t\t\t\t"
                          ),
                        ]),
                        _c("br"),
                        _c(
                          "span",
                          {
                            staticClass: "font_head",
                            staticStyle: { color: "red" },
                          },
                          [
                            _vm._v(
                              "\n\t\t\t\t\t\t\t\t《中国人寿财产保险股份有限公司意外伤害保险（互联网专属）类附加年龄规范保险条款（注册编号：C00010832322021122437413）》\n\t\t\t\t\t\t\t"
                            ),
                          ]
                        ),
                        _vm._v(
                          "\n\t\t\t\t\t\t\t兹经保险合同双方同意，鉴于投保人已了解保险方案中对被保险人年龄的限制，对于不符合保险方案规定年龄的被保险人，保险人不予承保。\n\t\t\t\t\t\t\t"
                        ),
                        _c("br"),
                        _vm._v(
                          "\n\t\t\t\t\t\t\t本保单承保被保险人年龄区间须为十六周岁（含）至六十五周岁（含）。\n\t\t\t\t\t\t\t"
                        ),
                        _c("br"),
                        _c(
                          "span",
                          {
                            staticClass: "font_head font_center",
                            staticStyle: {
                              color: "red",
                              "text-align": "center",
                            },
                          },
                          [
                            _vm._v(
                              "\n\t\t\t\t\t\t\t\t★投保人、被保险人未履行义务导致的责任免除★\n\t\t\t\t\t\t\t"
                            ),
                          ]
                        ),
                        _c(
                          "span",
                          {
                            staticClass: "font_head",
                            staticStyle: { color: "red" },
                          },
                          [
                            _vm._v(
                              "\n\t\t\t\t\t\t\t\t《中国人寿财产保险股份有限公司人身意外伤害保险（2022版）（互联网专属）条款（注册编号：C00010832312022042867271）》\n\t\t\t\t\t\t\t"
                            ),
                          ]
                        ),
                        _c("span", { staticClass: "font_title" }, [
                          _vm._v("【未及时交清保险费】"),
                        ]),
                        _c("br"),
                        _vm._v(
                          "\n\t\t\t\t\t\t\t 除另有约定外，投保人应当在保险合同成立时交清保险费。未交清保险费的，保险合同不生效，保险合同生效前发生保险事故的，保险人不承担保险责任。\n\t\t\t\t\t\t\t"
                        ),
                        _c("br"),
                        _c("span", { staticClass: "font_title" }, [
                          _vm._v("【未如实告知】"),
                        ]),
                        _c("br"),
                        _vm._v(
                          "\n\t\t\t\t\t\t\t 订立保险合同时，保险人就被保险人的有关情况提出询问的，投保人应当如实告知。\n\t\t\t\t\t\t\t"
                        ),
                        _c("br"),
                        _vm._v(
                          "\n\t\t\t\t\t\t\t 投保人故意或者因重大过失未履行前款规定的义务，足以影响保险人决定是否同意承保或者提高保险费率的，保险人有权解除本保险合同。\n\t\t\t\t\t\t\t"
                        ),
                        _c("br"),
                        _vm._v(
                          "\n\t\t\t\t\t\t\t 投保人故意不履行如实告知义务的，保险人对于保险合同解除前发生的保险事故，不承担给付保险金责任，并不退还保险费。\n\t\t\t\t\t\t\t"
                        ),
                        _c("br"),
                        _vm._v(
                          "\n\t\t\t\t\t\t\t 投保人因重大过失未履行如实告知义务，对保险事故的发生有严重影响的，保险人对于保险合同解除前发生的保险事故，不承担给付保险金责任，但应当退还保险费。\n\t\t\t\t\t\t\t"
                        ),
                        _c("br"),
                        _c("span", { staticClass: "font_title" }, [
                          _vm._v("【出险后未及时报案通知】"),
                        ]),
                        _c("br"),
                        _vm._v(
                          "\n\t\t\t\t\t\t\t 投保人、保险金申请人知道保险事故发生后，应当及时通知保险人。故意或者因重大过失未及时通知，致使保险事故的性质、原因、损失程度等难以确定的，保险人对无法确定的部分，不承担给付保险金责任，但保险人通过其他途径已经及时知道或者应当及时知道保险事故发生的除外。\n\t\t\t\t\t\t\t"
                        ),
                        _c("br"),
                        _vm._v(
                          "\n\t\t\t\t\t\t\t 上述约定，不包括因不可抗力而导致的迟延。\n\t\t\t\t\t\t\t"
                        ),
                        _c("br"),
                        _c(
                          "span",
                          {
                            staticClass: "font_head",
                            staticStyle: {
                              color: "red",
                              "text-align": "center",
                            },
                          },
                          [_vm._v("★按比例或部分赔付保险金的情形★")]
                        ),
                        _c(
                          "span",
                          {
                            staticClass: "font_head",
                            staticStyle: { color: "red" },
                          },
                          [
                            _vm._v(
                              "\n\t\t\t\t\t\t\t\t《中国人寿财产保险股份有限公司人身意外伤害保险（2022版）（互联网专属）条款（注册编号：C00010832312022042867271）》\n\t\t\t\t\t\t\t"
                            ),
                          ]
                        ),
                        _vm._v(
                          "\n\t\t\t\t\t\t\t一、被保险人身故前保险人已给付本条款约定的伤残保险金的，身故保险金为保险金额扣除已给付伤残保险金后的余额。\n\t\t\t\t\t\t\t"
                        ),
                        _c("br"),
                        _vm._v(
                          "\n\t\t\t\t\t\t\t二、被保险人自意外伤害发生之日起一百八十日内（含）因该事故身体伤残的，保险人根据本保险合同所附《人身保险伤残评定标准》（保监发[2014]6号，标准编号为JR/T\n\t\t\t\t\t\t\t0083-2013，以下简称“《伤残评定标准》”）的规定，按该标准所列伤残程度对应的保险金给付比例乘以本保险合同载明的保险金额给付伤残保险金。\n\t\t\t\t\t\t\t"
                        ),
                        _c("br"),
                        _vm._v(
                          "\n\t\t\t\t\t\t\t三、被保险人如在本次意外伤害事故之前已有伤残，保险人按合并后的伤残程度在《伤残评定标准》中所对应的给付比例给付伤残保险金，但应扣除原有伤残程度在《伤残评定标准》中所对应的伤残保险金。\n\t\t\t\t\t\t\t"
                        ),
                        _c("br"),
                        _c(
                          "span",
                          {
                            staticClass: "font_head",
                            staticStyle: {
                              color: "red",
                              "text-align": "center",
                            },
                          },
                          [_vm._v("★其他责任免除★")]
                        ),
                        _c("span", { staticClass: "font_title" }, [
                          _vm._v("【保险合同无效】"),
                        ]),
                        _c("br"),
                        _vm._v(
                          "\n\t\t\t\t\t\t\t 订立本保险合同时，投保人对被保险人不具有保险利益的，本保险合同无效，保险人退还净保费。\n\t\t\t\t\t\t\t"
                        ),
                        _c(
                          "span",
                          {
                            staticClass: "font_head",
                            staticStyle: {
                              color: "red",
                              "text-align": "center",
                            },
                          },
                          [_vm._v("★未尽事宜以条款和保险合同约定为准★")]
                        ),
                        _c("br"),
                      ]
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }